module.exports = __webpack_public_path__ + "static/media/chevron-down.c70d0733.svg";